// Third Party
import React from 'react';
import classNames from 'classnames';

// Components
import { ActivityList } from '../../components/activity-log';

// Utils
import { ACTIVITY_FORMAT } from '../../../utils/activity-log';
import Activity from '@/types/activity';

type Props = {
  className?: string;
  activityLogs: Activity[];
  loading: boolean;
  hasMore: boolean;
  onLoadMoreActivity: () => void;
  viewContactActivity: (id: string) => void;
  displayAsCards?: boolean;
  format: ACTIVITY_FORMAT;
};

const ActivityLogs = ({ className, activityLogs, loading, hasMore, displayAsCards, format, onLoadMoreActivity, viewContactActivity }: Props) => (
  <div className={classNames('activity-logs', className)}>
    <ActivityList
      activityLogs={activityLogs}
      format={format}
      loading={loading}
      hasMore={hasMore}
      onLoadMoreActivity={onLoadMoreActivity}
      displayAsCards={displayAsCards}
      viewContactActivity={viewContactActivity}
    />
  </div>
);

export default ActivityLogs;
